import { render, staticRenderFns } from "./SettlementClientMessage.vue?vue&type=template&id=f1f6099e"
import script from "./SettlementClientMessage.vue?vue&type=script&lang=js"
export * from "./SettlementClientMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports